var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "boss-main-container" }, [
    _c(
      "div",
      {
        staticClass:
          "boss-main-wrap boss-main-content-wrap pega-auto-reply-container",
      },
      [
        _c("setting-header", {
          attrs: {
            breadcrumbs: [{ name: "各種設定" }],
            title: "応募者管理＿自動受付メッセージ設定",
          },
        }),
        _vm._v(" "),
        _c(
          "div",
          [
            _c("h3", { staticClass: "boss-joboffer-title boss-setting" }, [
              _vm._v("\n        応募受付メッセージ自動送信設定\n      "),
            ]),
            _vm._v(" "),
            _c("form-label", {
              attrs: { label: "自動送信利用設定", "is-required": "" },
              scopedSlots: _vm._u([
                {
                  key: "body",
                  fn: function () {
                    return [
                      _c(
                        "div",
                        { staticClass: "pega-entry-auto-reply-relative" },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "pega-width-40 pega-auto-reply-item-area",
                            },
                            _vm._l(
                              _vm.autoReplyOptions.whetherToUses,
                              function (whetherToUse, i) {
                                return _c("div", { key: i }, [
                                  _c(
                                    "label",
                                    {
                                      staticClass: "pega-badge-radio pega-mr-5",
                                    },
                                    [
                                      _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value:
                                              _vm.autoReplySetting
                                                .isAvailableAutoReplyMail,
                                            expression:
                                              "autoReplySetting.isAvailableAutoReplyMail",
                                          },
                                        ],
                                        attrs: {
                                          type: "radio",
                                          "data-test":
                                            "use-auto-reply-radio" + i,
                                        },
                                        domProps: {
                                          value: whetherToUse.value,
                                          checked: _vm._q(
                                            _vm.autoReplySetting
                                              .isAvailableAutoReplyMail,
                                            whetherToUse.value
                                          ),
                                        },
                                        on: {
                                          change: function ($event) {
                                            return _vm.$set(
                                              _vm.autoReplySetting,
                                              "isAvailableAutoReplyMail",
                                              whetherToUse.value
                                            )
                                          },
                                        },
                                      }),
                                      _vm._v(" "),
                                      _c(
                                        "span",
                                        {
                                          staticClass:
                                            "pega-badge-radio-text pega-badge-radio-check-mark",
                                          attrs: {
                                            "data-test":
                                              "use-auto-reply-label" + i,
                                          },
                                        },
                                        [_vm._v(_vm._s(whetherToUse.label))]
                                      ),
                                    ]
                                  ),
                                ])
                              }
                            ),
                            0
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "pega-width-60 pega-annotation-text-padding",
                            },
                            [
                              _c("div", [
                                _c(
                                  "a",
                                  {
                                    attrs: {
                                      href: "/help/guide/index_273.html",
                                      "data-test": "use-manual-link",
                                      target: "_blank",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n                  応募受付自動送信機能とは？\n                "
                                    ),
                                  ]
                                ),
                              ]),
                            ]
                          ),
                        ]
                      ),
                    ]
                  },
                  proxy: true,
                },
              ]),
            }),
            _vm._v(" "),
            _c("form-label", {
              attrs: { label: "送信対象設定", "is-required": "" },
              scopedSlots: _vm._u([
                {
                  key: "body",
                  fn: function () {
                    return [
                      _c(
                        "div",
                        { staticClass: "pega-entry-auto-reply-relative" },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "pega-width-40 pega-auto-reply-item-area",
                            },
                            _vm._l(
                              _vm.autoReplyOptions.allReplies,
                              function (allReply, i) {
                                return _c("div", { key: i }, [
                                  _c(
                                    "label",
                                    {
                                      staticClass: "pega-badge-radio pega-mr-5",
                                    },
                                    [
                                      _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value:
                                              _vm.autoReplySetting
                                                .isNoAutoReplyForScoutEntry,
                                            expression:
                                              "autoReplySetting.isNoAutoReplyForScoutEntry",
                                          },
                                        ],
                                        attrs: {
                                          type: "radio",
                                          "data-test":
                                            "auto-reply-target-radio" + i,
                                        },
                                        domProps: {
                                          value: allReply.value,
                                          checked: _vm._q(
                                            _vm.autoReplySetting
                                              .isNoAutoReplyForScoutEntry,
                                            allReply.value
                                          ),
                                        },
                                        on: {
                                          change: function ($event) {
                                            return _vm.$set(
                                              _vm.autoReplySetting,
                                              "isNoAutoReplyForScoutEntry",
                                              allReply.value
                                            )
                                          },
                                        },
                                      }),
                                      _vm._v(" "),
                                      _c(
                                        "span",
                                        {
                                          staticClass:
                                            "pega-badge-radio-text pega-badge-radio-check-mark",
                                          attrs: {
                                            "data-test":
                                              "auto-reply-target-label" + i,
                                          },
                                        },
                                        [_vm._v(_vm._s(allReply.label))]
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  allReply.note
                                    ? _c(
                                        "small",
                                        {
                                          attrs: {
                                            "data-test":
                                              "auto-reply-target-note" + i,
                                          },
                                        },
                                        [_vm._v(_vm._s(allReply.note))]
                                      )
                                    : _vm._e(),
                                ])
                              }
                            ),
                            0
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "pega-width-60 pega-annotation-text-padding",
                            },
                            [
                              _c("div", [
                                _vm._v(
                                  "■ スカウトメールをご利用されている場合"
                                ),
                              ]),
                              _vm._v(" "),
                              _c("div", [
                                _vm._v(
                                  "・スカウト応募者に対して応募受付メッセージを自動送信したくない場合は除外設定が可能です。"
                                ),
                              ]),
                              _vm._v(" "),
                              _c("div", [
                                _vm._v(
                                  "例）すぐに面接案内をしたい/スカウト応募者には特別な対応をしたい など"
                                ),
                              ]),
                              _vm._v(" "),
                              _c("div", [
                                _vm._v(
                                  "※ただし、スカウト応募者限定の応募受付メッセージの設定はできませんので、個別の対応をお願い致します"
                                ),
                              ]),
                            ]
                          ),
                        ]
                      ),
                    ]
                  },
                  proxy: true,
                },
              ]),
            }),
            _vm._v(" "),
            _c("form-label", {
              attrs: { label: "送信時間設定", "is-required": "" },
              scopedSlots: _vm._u([
                {
                  key: "body",
                  fn: function () {
                    return [
                      _c(
                        "div",
                        { staticClass: "pega-entry-auto-reply-relative" },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "pega-width-40 pega-auto-reply-item-area",
                            },
                            [
                              _vm._l(
                                _vm.autoReplyOptions.sendImmediatelies,
                                function (sendImmediately, i) {
                                  return _c(
                                    "div",
                                    {
                                      key: i,
                                      staticClass:
                                        "pega-entry-auto-reply-relative",
                                    },
                                    [
                                      _c("div", [
                                        _c(
                                          "label",
                                          {
                                            staticClass:
                                              "pega-badge-radio pega-mr-5",
                                          },
                                          [
                                            _c("input", {
                                              attrs: {
                                                type: "radio",
                                                "data-test":
                                                  "sending-status-radio" + i,
                                              },
                                              domProps: {
                                                checked:
                                                  _vm.autoReplySetting
                                                    .isImmediatelySending ===
                                                  sendImmediately.value,
                                                value: sendImmediately.value,
                                              },
                                              on: {
                                                change: function ($event) {
                                                  return _vm.onChangeImmediatelySendingRadio(
                                                    sendImmediately.value
                                                  )
                                                },
                                              },
                                            }),
                                            _vm._v(" "),
                                            _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "pega-badge-radio-text pega-badge-radio-check-mark",
                                                attrs: {
                                                  "data-test":
                                                    "sending-status-label" + i,
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(sendImmediately.label)
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                      ]),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        _vm._l(
                                          sendImmediately.sendTimes,
                                          function (sendTime, j) {
                                            return _c(
                                              "label",
                                              {
                                                key: j,
                                                staticClass:
                                                  "boss-checkbox pega-label-margin",
                                                attrs: {
                                                  "data-test":
                                                    "sending-time-label" +
                                                    sendTime.value,
                                                },
                                              },
                                              [
                                                _c("input", {
                                                  staticClass:
                                                    "boss-input-checkbox",
                                                  attrs: {
                                                    type: "checkbox",
                                                    "data-test":
                                                      "sending-time-checkbox" +
                                                      sendTime.value,
                                                  },
                                                  domProps: {
                                                    checked:
                                                      _vm.autoReplySetting.sendingTimes.includes(
                                                        sendTime.value
                                                      ),
                                                    value: sendTime.value,
                                                  },
                                                  on: {
                                                    change:
                                                      _vm.onChangeCheckTime,
                                                  },
                                                }),
                                                _vm._v(
                                                  " " +
                                                    _vm._s(sendTime.label) +
                                                    "\n                  "
                                                ),
                                              ]
                                            )
                                          }
                                        ),
                                        0
                                      ),
                                    ]
                                  )
                                }
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "boss-layout boss-layout-start",
                                },
                                [
                                  _c(
                                    "span",
                                    { staticClass: "pega-send-time-label" },
                                    [
                                      _vm._v(
                                        "※送信したい時刻にチェックをしてください（複数選択可）"
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                            ],
                            2
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "pega-width-60 pega-annotation-text-padding",
                            },
                            [
                              _c("div", [_vm._v("■ 送信時間の設定について")]),
                              _vm._v(" "),
                              _c("div", [
                                _vm._v(
                                  "・応募頂いたタイミングでの即時送信か時間指定のいずれかを選択できます。"
                                ),
                              ]),
                            ]
                          ),
                        ]
                      ),
                    ]
                  },
                  proxy: true,
                },
              ]),
            }),
            _vm._v(" "),
            _c("form-label", {
              attrs: { label: "件名", "is-required": "" },
              scopedSlots: _vm._u([
                {
                  key: "body",
                  fn: function () {
                    return [
                      _c(
                        "div",
                        {
                          staticClass:
                            "pega-width-40 pega-auto-reply-item-area",
                        },
                        [
                          _c("small", [_vm._v("（100文字以内）")]),
                          _vm._v(" "),
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.autoReplySetting.mailSubject,
                                expression: "autoReplySetting.mailSubject",
                              },
                            ],
                            staticClass: "boss-send-subject",
                            attrs: {
                              type: "text",
                              "data-test": "mail-subject",
                            },
                            domProps: {
                              value: _vm.autoReplySetting.mailSubject,
                            },
                            on: {
                              input: function ($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.$set(
                                  _vm.autoReplySetting,
                                  "mailSubject",
                                  $event.target.value
                                )
                              },
                            },
                          }),
                        ]
                      ),
                    ]
                  },
                  proxy: true,
                },
              ]),
            }),
            _vm._v(" "),
            _c("form-label", {
              attrs: { label: "本文", "is-required": "" },
              scopedSlots: _vm._u([
                {
                  key: "body",
                  fn: function () {
                    return [
                      _c(
                        "div",
                        { staticClass: "pega-entry-auto-reply-relative" },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "pega-width-40 pega-auto-reply-item-area",
                            },
                            [
                              _c("small", [_vm._v("（2,000文字以内）")]),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "boss-textarea-button" },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticClass:
                                        "boss-button boss-button-compact",
                                      attrs: { "data-test": "user-name" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.insertionValue(
                                            "■USER_NAME■ 様"
                                          )
                                        },
                                      },
                                    },
                                    [_vm._v("応募者名を挿入")]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "span",
                                    {
                                      staticStyle: {
                                        "font-size": ".8125rem",
                                        padding: "4px 0",
                                      },
                                    },
                                    [_vm._v("（本文にのみ有効）")]
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c("textarea", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.autoReplySetting.mailText,
                                    expression: "autoReplySetting.mailText",
                                  },
                                ],
                                ref: "message",
                                staticClass: "boss-send-textarea",
                                attrs: {
                                  "data-test": "mail-text",
                                  rows: "",
                                  cols: "",
                                },
                                domProps: {
                                  value: _vm.autoReplySetting.mailText,
                                },
                                on: {
                                  input: function ($event) {
                                    if ($event.target.composing) {
                                      return
                                    }
                                    _vm.$set(
                                      _vm.autoReplySetting,
                                      "mailText",
                                      $event.target.value
                                    )
                                  },
                                },
                              }),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "pega-width-60 pega-annotation-text-padding",
                            },
                            [
                              _c("div", [_vm._v("■メッセージ作成について")]),
                              _vm._v(" "),
                              _c("div", { staticClass: "margin-top-1" }, [
                                _vm._v(
                                  "\n                応募者名挿入機能の使い方\n              "
                                ),
                              ]),
                              _vm._v(" "),
                              _c("div", [
                                _vm._v(
                                  "・本文にカーソルを合わせ、〔応募者名を挿入〕のボタンをクリックすると、≪ ■USER_NAME■ 様 ≫ と挿入されます。"
                                ),
                              ]),
                              _vm._v(" "),
                              _c("div", [
                                _vm._v(
                                  "・メッセージ送信時に自動的に応募者名に変換されます。"
                                ),
                              ]),
                              _vm._v(" "),
                              _c("div", [
                                _vm._v(
                                  "・ボタンを使用せずに、■USER_NAME■と直接記入して頂いても自動変換されますが、敬称がつきませんので、ご注意ください。"
                                ),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "margin-top-1" }, [
                                _vm._v(
                                  "\n                ■送信前にご確認いただきたいこと\n              "
                                ),
                              ]),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "pega-annotation-container margin-top-1",
                                },
                                [
                                  _c("div", [
                                    _vm._v(
                                      "・応募後の選考プロセスや選考期間を明記していますか？"
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("div", [
                                    _vm._v(
                                      "※選考方法や期間を明記することで応募者に安心感を与えることができます。"
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "margin-top-1" }, [
                                    _vm._v(
                                      "\n                  例)\n                "
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("div", [
                                    _vm._v(
                                      "「書類選考には1週間～10日程度お時間を頂いております。」"
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("div", [
                                    _vm._v(
                                      "「弊社では、web応募書類/履歴書/職務経歴書をもとに選考しております。"
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("div", [
                                    _vm._v(
                                      "お手数ではございますが、下記宛先に履歴書と職務経歴書をご送付頂けますでしょうか。"
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("div", [
                                    _vm._v(
                                      "なお、書類選考には書類到着から1～2週間ほどお時間を頂いております。」"
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "margin-top-1" }, [
                                    _vm._v(
                                      "\n                  ・不採用時の連絡の有無を明記していますか？\n                "
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("div", [
                                    _vm._v(
                                      "※不採用の場合もご連絡することをお勧めしています。"
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "margin-top-1" }, [
                                    _vm._v(
                                      "\n                  例）\n                "
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("div", [
                                    _vm._v(
                                      "「選考の結果は、合否に関わらずご連絡致します。」"
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("div", [
                                    _vm._v(
                                      "「選考の結果は、書類選考を通過された方にのみご連絡致します。」"
                                    ),
                                  ]),
                                ]
                              ),
                            ]
                          ),
                        ]
                      ),
                    ]
                  },
                  proxy: true,
                },
              ]),
            }),
            _vm._v(" "),
            _c("form-label", {
              attrs: { label: "署名" },
              scopedSlots: _vm._u([
                {
                  key: "body",
                  fn: function () {
                    return [
                      _c(
                        "div",
                        {
                          staticClass:
                            "pega-width-40 pega-auto-reply-item-area",
                        },
                        [
                          _c("small", [_vm._v("（600文字以内）")]),
                          _vm._v(" "),
                          _c("textarea", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.autoReplySetting.mailSignature,
                                expression: "autoReplySetting.mailSignature",
                              },
                            ],
                            staticClass: "pega-signature-textarea",
                            attrs: {
                              "data-test": "mail-signature",
                              rows: "",
                              cols: "",
                            },
                            domProps: {
                              value: _vm.autoReplySetting.mailSignature,
                            },
                            on: {
                              input: function ($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.$set(
                                  _vm.autoReplySetting,
                                  "mailSignature",
                                  $event.target.value
                                )
                              },
                            },
                          }),
                        ]
                      ),
                    ]
                  },
                  proxy: true,
                },
              ]),
            }),
            _vm._v(" "),
            _c("div", { staticClass: "margin-top-1 pega-flex-center" }, [
              _c(
                "button",
                {
                  staticClass: "boss-button boss-button-confirm pega-button",
                  attrs: { "data-test": "register-button" },
                  on: {
                    click: function ($event) {
                      return _vm.registerAutoReplySetting()
                    },
                  },
                },
                [
                  _c(
                    "span",
                    {
                      staticClass: "boss-button-confirm-text",
                      attrs: { "data-test": "confirm-button" },
                    },
                    [_vm._v("\n            上記内容で保存")]
                  ),
                ]
              ),
            ]),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }